export const statusViewId = 'products';
export const activeFilterViewId = 'default';
